// import core

import { library, dom } from '@fortawesome/fontawesome-svg-core'

// import only the icons we use

import {faLinkedin} from "@fortawesome/free-brands-svg-icons/faLinkedin";
import {faFacebook} from "@fortawesome/free-brands-svg-icons/faFacebook";  
import {faInstagram} from "@fortawesome/free-brands-svg-icons/faInstagram";

// library.add(
// )

// other
import {faAnglesDown} from "@fortawesome/pro-regular-svg-icons/faAnglesDown";
import {faChevronRight} from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import {faChevronDown} from "@fortawesome/pro-regular-svg-icons/faChevronDown";
import {faCheck} from "@fortawesome/pro-regular-svg-icons/faCheck";
import {faTimes} from "@fortawesome/pro-regular-svg-icons/faTimes";
import {faWarning} from "@fortawesome/pro-regular-svg-icons/faWarning";
import {faBars} from "@fortawesome/pro-regular-svg-icons/faBars";
import {faCalendar} from "@fortawesome/pro-regular-svg-icons/faCalendar";
import {faCalendarDays} from "@fortawesome/pro-regular-svg-icons/faCalendarDays";
import {faInfoCircle} from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import {faClose} from "@fortawesome/pro-regular-svg-icons/faClose";

library.add(
    faLinkedin,
    faFacebook,
    faInstagram,
    faAnglesDown,
    faChevronRight,
    faChevronDown,
    faCheck,
    faTimes,
    faWarning,
    faBars,
    faCalendar,
    faCalendarDays,
    faInfoCircle,
    faClose,
)

// add them to the DOM

dom.watch()